/**
 * 申し送り音声入力の標準語彙（Whisper プロンプト用）
 * Whisper が誤認識しやすい専門用語・略語・同音語リスクのある語に絞る。
 * 一般的な歯科用語（インプラント・クラウン等）はWhisperが既知のため不要。
 * 読み（こんち等）や句読点ワード（まる・てん等）は normalizeSpeechTranscript で処理するためここには含めない。
 */
export const DENTAL_SPEECH_TERMS_BASE: readonly string[] = [
  // 同音誤変換リスクが高い語
  '大臼歯',
  '小臼歯',
  '第一大臼歯',
  '第二大臼歯',
  '第一小臼歯',
  '第二小臼歯',
  '歯周ポケット',
  '歯槽膿漏',
  '歯肉退縮',
  'しにくたいしゅく',
  '骨吸収',
  '咬合',
  'こうごう',
  '咬合平面',
  '咬合調整',
  '窩洞形成',
  // 問診・全身（Whisper が起用歴・清暦等に化けやすい。読みのゆれをプロンプトにも載せる）
  '既往歴',
  'きおうれき',
  'きょうれき',
  'きようれき',
  // 麻酔（マス維持誤変換対策）
  '麻酔時',
  'ますいじ',
  // 根管まわり（誤変換実績あり）
  '根管治療',
  '根管充填',
  '神経除去',
  '仮封',
  '仮封材',
  // 補綴・修復
  'CR充填',
  'テック',
  'プロビ',
  'アンレー',
  'インレー',
  'ラミネートベニア',
  'グラスアイオノマー',
  'コンポジットレジン',
  'ルートプレーニング',
  // インプラント関連（専門複合語）
  'アバットメント',
  'フィクスチャー',
  'インプラント体',
  // 略語（Whisperが苦手なアルファベット略語）
  'PMTC',
  'TBI',
  'SPT',
  'SRP',
  'CBCT',
  'EOG',
  // 臨床スラング
  'スケーリング',
  'カリエス',
  // 同音誤変換（蒸し歯・振興 等）
  '虫歯',
  '虫歯の進行',
  '虫歯の進行はない',
  '虫歯の進行はなく',
  '進行はない',
  '進行はなく',
];
